import crypto from "crypto-js";
window.salt = 'C2F08C74DDEB153698D9B73E025C994CBE3BCEC8BF940E2D93FF026D0B04A245'

export const ivConstant = () => {
  let key3 = '';
  let key1;
  for (let i = 0; i < 8; i++) {
    key1 = Math.floor(10000000 + Math.random() * 89999999).toString(16);
    key3 += key1;
  }
  return key3.substring(0, 32)
}


export const hashKey = (data) => {
  let passPhrase = 'AQ3IC09T7B7SGYIK'
  window.iv = ivConstant()
  let key = crypto.PBKDF2(
    passPhrase,
    crypto.enc.Hex.parse(window.salt),
    {
      keySize: 8,
      iterations: 64,
      hasher: crypto.algo.SHA1
    })
  let cipher = crypto.AES.encrypt(JSON.stringify(data), key, {
    iv: crypto.enc.Hex.parse(window.iv),
    mode: crypto.mode.CBC,
    padding: crypto.pad.Pkcs7
  })
  return cipher.toString()
}

export const getTzOffset = () => {
  let offset = new Date().getTimezoneOffset()
  let sign = '-'
  let offsetInHours
  let offsetInHoursDecimal = offset / 60    // -5.5
  if (offset < 0) {
    sign = '+'
    offsetInHours = Math.ceil(offsetInHoursDecimal)
  } else {
    offsetInHours = Math.floor(offsetInHoursDecimal)
  }

  let offsetInHoursStr = Math.abs(offsetInHours)
  if (offsetInHours < 10) {
    offsetInHoursStr = '0' + offsetInHoursStr
  }
  let mins = '00'
  if (offset % 60) {
    mins = (Math.abs(offsetInHoursDecimal) - Math.abs(offsetInHours)) * 60
    if (mins < 10) {
      mins = '0' + mins
    }
  }
  return (sign + offsetInHoursStr + ':' + mins)
}